import React, { useEffect, useState } from 'react';
import HomeItem from '@/pages/agency/home/components/home-item/index.tsx';
import { hasFeatureFlag, hasRole } from '@/services';
import { Button, ButtonGroup } from '@tencent/spaui';
import './style.less';
import Icon from '@tencent/od-icon';
import { currencyFormat } from '@/pages/agency/utils/format.js';
import { REACT_APP_PUBLIC_URL } from '@/constants/Constants';
import actions from '@/pages/agency/account/chance-customer/api';
import TipIcon from '@/common-components/tip-icon';
import dayjs from 'dayjs';

const getPercent = (a, b) => {
  const num = a / b;
  if (isNaN(num)) {
    return '-';
  }
  return `${(num * 100).toFixed(2)}%`;
};

export default () => {
  // 管理员101 超级管理员100 运营管理员 114
  const hasChanceBoardRole = hasFeatureFlag('is_diagnose_opportunity_enable') && (hasRole(101) || hasRole(100) || hasRole(114));

  const [btnVal, setBtnVal] = useState(0);
  const [detailData, setDetailData] = useState({});

  const {
    large_opportunity_cost = 0, // 最大机会消耗
    large_opportunity_count = 0, // 最大机会数量
    medium_opportunity_cost = 0, // 中等机会消耗
    medium_opportunity_count = 0, // 中等机会数量
    opportunity_cost = 0, // 有提升机会的客户消耗
    opportunity_count = 0, // 有提升机会的客户总数
    partition_time, // 更新时间
    short_advertiser_name_cost = 0, // 总客户消耗
    short_advertiser_name_count = 0, // 总客户数量
    small_opportunity_cost = 0, // 最小机会消耗
    small_opportunity_count = 0, // 最小机会数量
  } = detailData;

  const startDate = partition_time ? dayjs(partition_time).subtract(14, 'day')
    .format('YYYY-MM-DD') : '-';

  useEffect(() => {
    if (!hasChanceBoardRole) {
      return;
    }
    actions.getTotalData({
      customer_type: btnVal,
    }).then((res) => {
      setDetailData(res.data || {});
    });
  }, [btnVal, hasChanceBoardRole]);

  if (!hasChanceBoardRole) {
    return null;
  }

  return <HomeItem
    header={(
      <div className="flex-1">
        <div className="flex justify-between flex-1">
          <ButtonGroup
            activeDisplayType='primary'
            value={btnVal}
            onChange={(e, v) => setBtnVal(v)}
            theme="light"
          >
            <Button value={0}>全部客户</Button>
            <Button value={1}>
              <TipIcon value='重点客户' overlayTriggerProps={{ placement: 'top', alignment: 'auto' }}>
                <div>
                  在「客户-账户管理-账户列表」中点击了「收藏」的账户，其所对应的主体计为重点客户
                </div>
              </TipIcon>
            </Button>
          </ButtonGroup>
          <div className="chance-board-more">
            <span>{`所示数据的时间范围：${startDate} 至 ${partition_time ? dayjs(partition_time).format('YYYY-MM-DD') : '-'}`}</span>
            <Button
              className="chance-more"
              displayType="link"
              endIcon={<Icon name="right-outlined"/>}
              data-report="home-jump-chance-more"
              onClick={() => window.open(`${REACT_APP_PUBLIC_URL}/agency-workspace/dashboard-chance/customer`)}
            >
              更多
            </Button>
          </div>
        </div>
      </div>
    )}
  >
    <div className='flex home-chance-board' style={{ flexWrap: 'wrap', gap: '16px' }}>
      <section className='custom-data'>
        <div className='detail-title'>
          <TipIcon value='客户分布' overlayTriggerProps={{ placement: 'top' }}>
            <div>
              <div>您负责的客户下，存在提升空间的客户分布。</div>
              <div>注意：不包含近3天无消耗客户，不包含近14天日耗低于500元客户。</div>
            </div>
          </TipIcon>
        </div>
        <div className='detail-container flex'>
          <div className='detail-content justify-between'>
            <div>
              <div className='detail-content-title'>
                <TipIcon value='有提升空间的客户总数' overlayTriggerProps={{ placement: 'top' }}>
                  <div>
                    <div>有提升空间定义：近 14 天客户主体消耗增长速率高于自身，导致自身在客户主体下消耗份额下降，需重点提升。</div>
                  </div>
                </TipIcon>
              </div>
              <section className='num-content'>
                <span>{opportunity_count}</span>
              </section>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div className='detail-content-title'>占总客户比</div>
              <section className='num-content'>
                <span style={{ color: 'rgb(90, 199, 36)' }}>
                  {getPercent(opportunity_count, short_advertiser_name_count)}
                </span>
              </section>
            </div>
          </div>
          <div className='detail-content justify-between'>
            <div>
              <div className='detail-content-title'>有提升空间的客户消耗</div>
              <section className='num-content'>
                <span>{currencyFormat(opportunity_cost)}</span>
              </section>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div className='detail-content-title'>占总消耗比</div>
              <section className='num-content'>
                <span style={{ color: 'rgb(90, 199, 36)' }}>
                  {getPercent(opportunity_cost, short_advertiser_name_cost)}
                </span>
              </section>
            </div>
          </div>
        </div>
      </section>
      <section className='chance-data'>
        <div className='detail-title'>
          <TipIcon value='机会分布' overlayTriggerProps={{ placement: 'top' }}>
            <div>机会分布指您所负责的客户下，有较大提升空间客户的占比。</div>
          </TipIcon>
        </div>
        <div className='detail-container flex'>
          <div className='detail-content justify-between'>
            <div>
              <div className='detail-content-title'>提升空间大的客户总数</div>
              <section className='num-content'>
                <span>{large_opportunity_count}</span>
              </section>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div className='detail-content-title'>占有提升空间客户比</div>
              <section className='num-content'>
                <span style={{ color: 'rgb(90, 199, 36)' }}>
                  {getPercent(large_opportunity_count, opportunity_count)}
                </span>
              </section>
            </div>
          </div>
          <div className='detail-content justify-between'>
            <div>
              <div className='detail-content-title'>提升空间大的客户消耗</div>
              <section className='num-content'>
                <span>{currencyFormat(large_opportunity_cost)}</span>
              </section>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div className='detail-content-title'>占有提升空间客户消耗比</div>
              <section className='num-content'>
                <span style={{ color: 'rgb(90, 199, 36)' }}>
                  {getPercent(large_opportunity_cost, opportunity_cost)}
                </span>
              </section>
            </div>
          </div>
        </div>
      </section>
    </div>
  </HomeItem>;
};
